export default __webpack_public_path__ + "static/media/24.cb6e22b4.svg";